import styled from 'styled-components'

export const NpsDesktop = styled.div`
  display: flex;
  flex-direction: row;
  gap: 3px;
  overflow-x: auto;

  @media (max-width: 768px) {
    display: none !important;
  }
`

export const NpsMobile = styled.div`
  display: none;
  flex-direction: column;
  gap: 3px;

  @media (max-width: 768px) {
    display: flex !important;
  }
`
